<template>
  <b-modal
      id="intervention-delete-modal"
      :title="'Supprimer ' + $t('a.intervention')"
      @ok="handleOk"
      :ok-title="$t('Delete')"
      ok-variant="danger"
      :cancel-title="$t('Cancel')"
      cancel-variant="danger"
  >

    <div v-if="!!selectedIntervention">
        {{ $t('Delete') }} {{ $t('l.intervention') }} "{{ interventionDisplay }}" ? {{$t('intervention.delete.message')}}
    </div>
  </b-modal>
</template>

<script>

import api from '../../services/api';
import {dateUtils} from "../../mixins/utils";

export default {

  name: 'InterventionDeleteModal',
  mixins: [dateUtils],

  props: {
    selectedIntervention: Object
  },

  data() {
    return {
      canBeDeleted: false
    }
  },


  watch: {
    'selectedIntervention': function () {
      this.checkDelete()
    }
  },

  computed: {
    interventionDisplay() {
      return this.formatDate(this.selectedIntervention ? this.selectedIntervention.estimatedStartDate : "")
    }
  },

  emits: ['didDeleteIntervention'],


  methods: {

    checkDelete() {
      this.canBeDeleted = this.selectedIntervention &&  !this.selectedIntervention.fileInterventionCount
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      let interventionName = this.formatDate(this.selectedIntervention.estimatedStartDate)

      api
          .delete(`/intervention/${this.selectedIntervention.id}`)
          .then(response => {
            this.$emit('didDeleteIntervention')
            this.hideModal()
            this.successToast(this.$i18n.t('Intervention') + ' "' + interventionName + '" ' + this.$i18n.t('deleted'))
          })
          .catch((error) => {
            if (error.response.status === 418) {
              this.$bvToast.toast(error.response.data.message, {
                autoHideDelay: 2000,
                toaster: 'b-toaster-bottom-right'
              })
            }
          });
    },

    hideModal() {
      this.$bvModal.hide('intervention-delete-modal')
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/intervention/InterventionDeleteModal.vue